<template>
    <div id="jobDetail">
        <div class="mcontainer" v-if="event">
            <div class="card">
                <div class="h-44 mb-4 md:h-72 overflow-hidden relative rounded-t-lg w-full" v-if="event.image || event.images">
                    <img :src="event.image || event.images" alt="" class="w-full h-full absolute inset-0 object-cover">
                </div>
                <div class="p-4">
                    <h1 class="lg:text-2xl text-xl font-semibold mb-6">{{ event.title }}</h1>
                    <div class="flex items-center space-x-3 my-3 pb-4 border-b flex-wrap">
                        <img :src="require('@/assets/images/avatars/avatar-1.jpg')" class="w-10 h-10 rounded-full">
                        <div>
                            <div class="text-base font-semibold"> Administrator </div>
                            <div class="text-xs"> {{ event.date_format || event.date }} <Icon icon="fontisto:map-marker-alt" style="margin-top: -3px;" class="mr-1 d-inline ml-2" /> {{ event.location }}</div>
                        </div>
                        <a :href="event.register_url" target="_blank" style="margin-left: auto;" class="btn btn-primary" v-if="event.expired !== '1' && (event.show_button === '1' || event.show_button === true)">Register</a>
                    </div>
                    <div class="space-y-3" v-html="event.description">
                    </div>
                    <br><br>
                </div>
            </div>
        </div>
        <div v-else class="mcontainer p-8 text-center"><b-spinner /> Loading...</div>
    </div>
</template>
<script>
    import axios from 'axios'
    import { Icon } from '@iconify/vue2'

    export default {
        components: {
            Icon
        },
        data () {
            return {
                event: null
            }
        },
        created () {
            this.fetchData()
        },
        methods: {
            fetchData () {
                const $this = this
                axios.get('/events/' + encodeURIComponent(this.$route.params.code)).then(function (response) {
                    $this.event = response.data
                }).catch(function () {
                    $this.event = null
                })
            }
        }
    }
</script>
